import COLORS from './colors';

// Segments are dynamic (unlike the fixed Smart Assist source types), so the
// donut assigns colors by cycling this palette in the order segments come back.
export const SEGMENT_DONUT_PALETTE = [
  COLORS.green,
  COLORS.blue,
  COLORS.orange,
  COLORS.red,
  COLORS.lavender,
  COLORS.tangerine,
  COLORS.medium_turquoise,
  COLORS.yellow,
  COLORS.grass,
  COLORS.celestial_blue,
];

const lynqAiQueriesBySegmentChartConfig = {
  title: 'Questions by segment',
  helpText: 'metrics_tab.smart_assist_tab.overview_tab.queries_by_segment.help_text',
  exportType: 'tabular_chart_data',
  graphParams: {
    dataNameField: 'name',
    dataValueField: 'value',
    // d3 external legend at the top, matching the Smart Assist donut.
    showExternalLegend: true,
  },
};

export default lynqAiQueriesBySegmentChartConfig;
